// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItem-cls1__de31386ca4e361c03b6a{/*!*/}.CreateSocialItem-cls2___1e38cbaa059e5983c12{display:flex;align-items:center;justify-content:space-between}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItem-cls1__de31386ca4e361c03b6a",
	"cls2": "CreateSocialItem-cls2___1e38cbaa059e5983c12 CreateSocialItem-cls1__de31386ca4e361c03b6a"
};
export default ___CSS_LOADER_EXPORT___;
